import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'ТехАрена';
const DEFAULT_DESCRIPTION = 'Платформа для аренды спецтехники напрямую между заказчиками и исполнителями. Без посредников, проверенные исполнители, доступно 24/7.';
const DEFAULT_URL = 'https://mininikovpn.duckdns.org';
const DEFAULT_IMAGE = `${DEFAULT_URL}/og-image.png`;

const SEO = ({
  title,
  description = DEFAULT_DESCRIPTION,
  url,
  image,
  type = 'website',
  noindex = false,
}) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Аренда спецтехники рядом с вами`;
  const canonicalUrl = url || (typeof window !== 'undefined' ? window.location.href : DEFAULT_URL);
  const ogImage = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="ru_RU" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEO;
